import { Component } from '@angular/core';

@Component({
    selector: 'atlas-legal',
    templateUrl: './legal.component.html',
    styleUrls: ['./legal.component.less'],
    standalone: false
})
export class LegalComponent {
  constructor() {}
}
